import React, { FC, useRef } from 'react';
import Label from "../Label/Label";
import ErrorText from "../ErrorText/ErrorText";
import { clss } from '../../../../utils/helpers/styleHelpers';

import styles from './checkboxField.module.scss';

type CheckboxFieldPropTypes = {
    name: string;
    label: string;
    register?: any;
    orderIndex?: number;
    errorMessage?: string;
    defaultValue?: boolean;
    style?: any;
    onChange?: (value: any) => void;
    extraContent?: any;
    props?: any;
};

/**
 * Custom checkbox for Form component
 * */

const CheckboxField: FC<CheckboxFieldPropTypes> = (props) => {
    const {
        name,
        label,
        register,
        orderIndex,
        errorMessage,
        defaultValue,
        style,
        onChange,
        extraContent,
        props: outerProps,
    } = props;

    const inputRef = useRef<HTMLInputElement>(null);
    const isControlled = typeof outerProps?.checked !== "undefined";

    const handleClick = () => {
        if (inputRef.current) {
            inputRef.current.click();
        }
    };

    return (
        <div key={name} style={{ order: orderIndex, ...style }}>
            <div className={clss([styles.checkboxWrapper, "checkbox-field-wrapper"])}>
                <input
                    type="checkbox"
                    {...outerProps}
                    {...register?.(name as `${string}`)}
                    defaultChecked={isControlled ? undefined : defaultValue}
                    className={`${styles.checkbox} ${outerProps?.className || ""}`}
                    onChange={(e) => onChange?.(e.target.checked)}
                />
                <span className={styles.mark} />
                <Label name={name} label={label} onClick={handleClick} />
            </div>
            <ErrorText text={errorMessage} />
            {!!extraContent && extraContent()}
        </div>
    );
};

export default CheckboxField;